// Dashboard Activity — client-side search filtering, tab switching, and FAB toggle
// Avoids inline script CSP violations

function initDashboardActivity () {
  const searchInput = document.getElementById('activity-search-input')
  const cards = document.querySelectorAll('.activity-card')
  const noResults = document.getElementById('no-activity-results')
  const tabButtons = document.querySelectorAll('.activity-tab-btn')

  if (!cards.length) return
  if (searchInput && searchInput.dataset.initialized) return
  if (searchInput) searchInput.dataset.initialized = 'true'

  let currentFilter = 'all'
  let currentQuery = ''

  function applyFilter () {
    let visibleCount = 0

    cards.forEach(card => {
      const cardType = (card.dataset.activityType || '').toLowerCase()
      const cardTitle = (card.dataset.activityTitle || '').toLowerCase()
      const cardText = card.textContent.toLowerCase()

      const matchesType = currentFilter === 'all' || cardType === currentFilter
      const matchesQuery = !currentQuery || cardTitle.includes(currentQuery) || cardText.includes(currentQuery)

      if (matchesType && matchesQuery) {
        card.classList.remove('hidden')
        visibleCount++
      } else {
        card.classList.add('hidden')
      }
    })

    if (noResults) {
      noResults.classList.toggle('hidden', visibleCount > 0)
    }
  }

  if (searchInput) {
    searchInput.addEventListener('input', function (e) {
      currentQuery = e.target.value.toLowerCase().trim()
      applyFilter()
    })
  }

  tabButtons.forEach(btn => {
    btn.addEventListener('click', function () {
      currentFilter = btn.dataset.filter || 'all'

      tabButtons.forEach(b => {
        if (b === btn) {
          b.classList.remove('font-medium', 'text-gray-600')
          b.classList.add('font-bold', 'text-[#043f42]', 'bg-white')
          b.setAttribute('aria-selected', 'true')
        } else {
          b.classList.remove('font-bold', 'text-[#043f42]', 'bg-white')
          b.classList.add('font-medium', 'text-gray-600')
          b.setAttribute('aria-selected', 'false')
        }
      })

      applyFilter()
    })
  })
}

function initDashboardFab () {
  const trigger = document.getElementById('dashboard-fab-trigger')
  const menu = document.getElementById('dashboard-fab-menu')
  const backdrop = document.getElementById('dashboard-fab-backdrop')
  const icon = document.getElementById('dashboard-fab-icon')

  if (!trigger || !menu) return
  if (trigger.dataset.initialized) return
  trigger.dataset.initialized = 'true'

  function toggleMenu (open) {
    const shouldOpen = open !== undefined ? open : menu.classList.contains('hidden')
    if (shouldOpen) {
      menu.classList.remove('hidden')
      if (backdrop) backdrop.classList.remove('hidden')
      if (icon) icon.classList.add('rotate-45')
      trigger.setAttribute('aria-expanded', 'true')
    } else {
      menu.classList.add('hidden')
      if (backdrop) backdrop.classList.add('hidden')
      if (icon) icon.classList.remove('rotate-45')
      trigger.setAttribute('aria-expanded', 'false')
    }
  }

  trigger.addEventListener('click', function (e) {
    e.stopPropagation()
    toggleMenu()
  })

  if (backdrop) {
    backdrop.addEventListener('click', function () {
      toggleMenu(false)
    })
  }

  menu.addEventListener('click', function () {
    toggleMenu(false)
  }, true)

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !menu.classList.contains('hidden')) {
      toggleMenu(false)
    }
  })
}

function initDashboardComponents () {
  initDashboardActivity()
  initDashboardFab()
}

document.addEventListener('turbo:load', initDashboardComponents)
document.addEventListener('DOMContentLoaded', initDashboardComponents)
